import React, { MouseEventHandler } from "react";

import {
  styled,
  Box,
  Flex,
  $fontWeightNormal,
  $fontSize
} from "@acko-tech/building-blocks.ui.common";
import { ButtonText } from "@acko-tech/building-blocks.ui.button-old";
import { INudgeTipContent } from "@components/car/journey/types";
import { PrimaryButton } from "@acko-tech/building-blocks.ui.button";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { keyframes } from "styled-components";
import { isnpBasePath } from "@utils/isnp";
import InfoIcon from "@public/images/info-icon-black.svg";

interface CTAProps {
  price: string;
  ctaText?: string;
  clickHandler?: Function;
  isDesktop?: boolean;
  premiumBreakupClickHandler?: Function;
  hidePremiumBreakupCta?: boolean;
  isGstPrice?: boolean;
  showNudgeTip?: boolean;
  nudgeTipContent?: INudgeTipContent | null;
  nudgeTipClickhandler?: Function;
  hidePriceSection?: boolean;
  showtermAndCon?: boolean;
  onTermAndConClick?: MouseEventHandler;
  twoColLayout?: any;
  disabled?: boolean;
  showInclusiveText?: boolean | any;
  nudgeTipHyperlinkText?: string;
  hideCta?: boolean;
  skinnyBanner?: boolean;
  skinnyBannerContent?: React.ReactNode;
}

const Hyperlink = styled(ButtonText)`
  font-size: 12px
  font-weight: 500;
  line-height: 16px;
  color: #1b73e8;
  width: max-content;
  display: inline-block;

  @media (min-width: 768px) {
    font-size: 14px
    line-height: 20px;
  }
`;

const StickyWrapper = styled.div`
  width: 100%;
  background: white;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 14px;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.05);

  @media (min-width: 768px) {
    display: flex;
    padding: 14px 0px;
    justify-content: center;
  }
`;

const Container = styled(Flex)`
  max-width: 980px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 768px) {
    max-width: auto;
    margin: 0;
    width: ${props => (props.twoColLayout ? "74%" : "68%")};
    justify-content: ${props =>
    props.hidePriceSection ? "flex-end" : "space-between"};
  }

  ${props =>
    props.hidePriceSection &&
    props.showtermAndCon &&
    `
    flex-direction: column-reverse;

    @media (min-width: 768px) {
      flex-direction: row;
      justify-content: space-between;
    }
  `}
`;

const Wrapper = styled.div`
  @media (min-width: 768px) {
    display: flex;
    width: ${props => (props.twoColLayout ? "1080px" : "800px")};
    justify-content: flex-end;
  }
`;

const PriceText = styled.div`
  font-weight: 700;
  font-size: 22px;
  color: #282e33;
`;
const NudgeTip = styled.div`
  position: absolute;
  top: -40px;
  left: 0;
  width: 100vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: ${$fontWeightNormal};
  font-size: ${$fontSize.xxs};
  line-height: 12px;
  color: #040222;

  @media (min-width: 768px) {
    display: flex;
    padding: 14px 0px;
    justify-content: center;
    top: -62px;
  }
`;

const NudgeWrapper = styled.div`
  width: 100%;

  @media (min-width: 768px) {
    display: flex;
    width: 800px;
    justify-content: flex-end;
  }
`;

const NudgeContainer = styled.div`
  background: ${props =>
    props?.background
      ? props?.background
      : "linear-gradient(290deg, #ffe380 2.08%, #fff7e5 126.01%)"};
  border-radius: 10px 10px 0px 0px;
  padding: 14px 20px;
  justify-content: space-between;
  align-items: center;
  display: flex;

  @media (min-width: 768px) {
    max-width: auto;
    margin: 0;
    width: 68%;
  }
`;

const CtaContainer = styled(Box)`
  width: 100%;

  @media (min-width: 768px) {
    width: 224px;
  }
`;

const Note = styled(Text)`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #5b5675;
  margin-left: ${props => (props.ml ? props.ml : "12px")};
  margin-top: ${props => props.mt};
  padding-top: 16px;
  text-align: center;

  @media (min-width: 768px) {
    padding-top: 0px;
  }
`;
const skeletonAnimation = keyframes`
100% {
      transform: translateX(100%);
    }
`;

const SkeletonPrice = styled.div`
  display: inline-block;
  height: 1em;
  position: relative;
  overflow: hidden;
  background-color: #dddbdd;
  width: 110px;
  height: 30px;
  border-radius: 5px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0)
    );
    content: "";
    animation: ${skeletonAnimation} 2s infinite;
  }
`;

const SkinnyBanner = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: -40px;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #040222;
  height: 40px;
  margin-bottom: -1rem;
  padding-bottom: 1rem;
  padding-top: 1rem
  font-family: Euclid Circular B;
  border-radius: 10px 10px 0px 0px;
  border-radius: 0px;

  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
    border-radius: 10px 10px 0px 0px;
    font-size: 16px;
  }
  
  ${(props) => {
    switch (props.type) {
      case "INFO":
        return `
      background: linear-gradient(91deg, #fff4da 0%, #fff0e5 100%);
      `;
      case "SUCCESS":
        return `
        background: #EBFBEE;
      `;
      case "GENERAL":
        return `
        background: #EFEFF5;
      `;
      default:
        return `
        background: linear-gradient(91deg, #fff4da 0%, #fff0e5 100%);
        `;
    }
  }}
`;

const InfoIconStyled = styled(InfoIcon)`
  margin-right: 8px;
`;

const StickyFooter = ({
  price,
  ctaText,
  clickHandler,
  // isDesktop,
  premiumBreakupClickHandler,
  hidePremiumBreakupCta,
  isGstPrice,
  showNudgeTip,
  nudgeTipContent,
  nudgeTipClickhandler,
  hidePriceSection,
  showtermAndCon = false,
  onTermAndConClick,
  twoColLayout,
  disabled,
  showInclusiveText = false,
  hideCta,
  skinnyBanner = false,
  skinnyBannerContent
}: CTAProps) => {
  return (
    <StickyWrapper>
      {
          skinnyBanner && (
            <SkinnyBanner>
              <InfoIconStyled/>
              {skinnyBannerContent}
            </SkinnyBanner>
          )
      }
      {showNudgeTip && nudgeTipContent !== null && (
        <div
          onClick={() => {
            nudgeTipClickhandler && nudgeTipClickhandler();
          }}
        >
          <NudgeTip>
            <NudgeWrapper>
              <NudgeContainer background={nudgeTipContent?.background}>
                {nudgeTipContent?.text}
                <Hyperlink style={nudgeTipContent?.hyperlinkTextStyles}>
                  {nudgeTipContent?.hyperlinkText}
                </Hyperlink>
              </NudgeContainer>
            </NudgeWrapper>
          </NudgeTip>
        </div>
      )}
      <Wrapper twoColLayout={twoColLayout}>
        <Container
          twoColLayout={twoColLayout}
          hidePriceSection={hidePriceSection}
          showtermAndCon={showtermAndCon}
        >
          {!hidePriceSection && (
            <Flex flexDirection="column">
              {!price ? (
                <div>
                  <SkeletonPrice />
                </div>
              ) : (
                <>
                  <PriceText>
                    ₹{price}{" "}
                    {showInclusiveText && isGstPrice && (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "400",
                          lineHeight: "16px",
                          color: "#5b5675"
                        }}
                      >
                        (Incl. GST)
                      </span>
                    )}
                    {!isGstPrice && (
                      <span
                        style={{
                          fontWeight: 400,
                          fontSize: "12px",
                          lineHeight: "16px",
                          color: "#5B5675"
                        }}
                      >
                        + 18% GST
                      </span>
                    )}
                  </PriceText>
                  {!hidePremiumBreakupCta && (
                    <Hyperlink
                      onClick={() =>
                        premiumBreakupClickHandler &&
                        premiumBreakupClickHandler()
                      }
                    >
                      Premium breakup
                    </Hyperlink>
                  )}
                </>
              )}
            </Flex>
          )}
          {hidePriceSection && showtermAndCon && (
            <Note ml="0px">
              By proceeding, you agree to
              <a
                onClick={onTermAndConClick}
                href={`${process.env.HOST_URL}${isnpBasePath}/terms-and-conditions/`}
                style={{
                  color: "#1B73E8",
                  textDecoration: "none"
                }}
                target="_blank"
              >
                {` Terms & Conditions `}
              </a>
            </Note>
          )}
          {!hideCta && (
            <CtaContainer>
              <PrimaryButton
                isFullWidth={hidePriceSection}
                onClick={e => {
                  clickHandler && clickHandler(e);
                }}
                disabled={disabled}
                style={{ cursor: disabled ? "not-allowed" : "pointer" }}
              >
                {ctaText || "Customise"}
              </PrimaryButton>
            </CtaContainer>
          )}
        </Container>
      </Wrapper>
    </StickyWrapper>
  );
};

export default StickyFooter;
